import React, { useEffect, useState } from 'react';
// Inline SVGs to avoid pulling lucide-react into the eager bundle.
const Eye = ({
  style
}: {
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" style={style} aria-hidden data-id="element-307">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" data-id="element-308" />
    <circle cx="12" cy="12" r="3" data-id="element-309" />
  </svg>;
const Flame = ({
  style
}: {
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" style={style} aria-hidden data-id="element-310">
    <path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z" data-id="element-311" />
  </svg>;
const Zap = ({
  style
}: {
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" style={style} aria-hidden data-id="element-312">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" data-id="element-313" />
  </svg>;
export function SocialProofBar() {
  const [viewers, setViewers] = useState(24);
  const [buyers, setBuyers] = useState(68);
  const [spots, setSpots] = useState(147);
  useEffect(() => {
    let intervalId: number | undefined;
    const start = () => {
      intervalId = window.setInterval(() => {
        setViewers(v => Math.max(18, Math.min(34, v + (Math.random() > 0.5 ? 1 : -1))));
        if (Math.random() > 0.85) setBuyers(b => b + 1);
        if (Math.random() > 0.9) setSpots(s => Math.max(80, s - 1));
      }, 6000);
    };
    const ric = (window as any).requestIdleCallback as ((cb: () => void, opts?: {
      timeout: number;
    }) => number) | undefined;
    const timeoutId = ric ? ric(start, {
      timeout: 4000
    }) : window.setTimeout(start, 3000);
    return () => {
      if (intervalId) clearInterval(intervalId);
      const cic = (window as any).cancelIdleCallback as ((id: number) => void) | undefined;
      if (ric && cic) cic(timeoutId as number);else clearTimeout(timeoutId as number);
    };
  }, []);
  return <section className="w-full py-4 md:py-5 px-4 md:px-6" style={{
    background: '#112240'
  }} data-id="element-314">
      <div className="max-w-6xl mx-auto" data-id="element-315">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 text-center text-white" data-id="element-316">
          <div className="flex items-center justify-center gap-2 sm:gap-2.5" data-id="element-317">
            <Eye style={{
            color: '#FFD700'
          }} data-id="element-318" />
            <span className="text-xs sm:text-sm md:text-base" data-id="element-319">
              <span className="font-bold tabular-nums" style={{
              color: '#FFD700'
            }} data-id="element-320">
                {viewers}
              </span>{' '}
              osoby oglądają tę stronę teraz
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 sm:gap-2.5" data-id="element-321">
            <Flame style={{
            color: '#FFD700'
          }} data-id="element-322" />
            <span className="text-xs sm:text-sm md:text-base" data-id="element-323">
              <span className="font-bold tabular-nums" style={{
              color: '#FFD700'
            }} data-id="element-324">
                {buyers}
              </span>{' '}
              nauczycieli kupiło dzisiaj
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 sm:gap-2.5" data-id="element-325">
            <Zap style={{
            color: '#FFD700'
          }} data-id="element-326" />
            <span className="text-xs sm:text-sm md:text-base" data-id="element-327">
              Zostało tylko{' '}
              <span className="font-bold tabular-nums" style={{
              color: '#FFD700'
            }} data-id="element-328">
                {spots}
              </span>{' '}
              miejsc z 200
            </span>
          </div>
        </div>
      </div>
    </section>;
}